import _objectSpread from "/Users/fangyu/Code/unifygama/metacrm/metadesk-frontend/node_modules/@babel/runtime/helpers/esm/objectSpread2.js";
import { proxy, subscribe as sub, snapshot } from 'valtio/vanilla';
const state = proxy({
  themeMode: 'dark',
  themeVariables: {}
});
export const ThemeController = {
  state,
  subscribe(callback) {
    return sub(state, () => callback(state));
  },
  setThemeMode(themeMode) {
    state.themeMode = themeMode;
  },
  setThemeVariables(themeVariables) {
    state.themeVariables = _objectSpread(_objectSpread({}, state.themeVariables), themeVariables);
  },
  getSnapshot() {
    return snapshot(state);
  }
};
//# sourceMappingURL=ThemeController.js.map